import React, { SyntheticEvent, useContext } from 'react';
import FavoriteIcon from './FavoriteIcon';
import { TileKitContext } from '../TileKit/TileKit';
import './FavoriteVehicle.scss';

interface FavoriteVehicleProps {
  handleFavorite: () => void;
}

const FavoriteVehicle: React.VFC<FavoriteVehicleProps> = ({
  handleFavorite
}) => {
  const { vehicle } = useContext(TileKitContext);

  const submitFavorite = () => {
    if (!vehicle?.stockNumber) {
      return;
    }

    handleFavorite();
  };

  const handleOnClick = (event: SyntheticEvent) => {
    event.preventDefault();
    event.stopPropagation();
    submitFavorite();
  };

  const handleOnKeyUp = (event: SyntheticEvent<any, KeyboardEvent>) => {
    const { key } = event.nativeEvent;
    if (key && key.toLowerCase() === 'enter') {
      submitFavorite();
    }
  };

  return (
    <div
      className="favorite-vehicle"
      onClick={handleOnClick}
      onKeyUp={handleOnKeyUp}
      role="button"
      aria-pressed="false"
      tabIndex={0}
      data-qa="favorite-vehicle"
    >
      <FavoriteIcon isFavorite={vehicle?.isFavorite ?? false} />
    </div>
  );
};

export default FavoriteVehicle;
